import {
    LOGIN_REQUEST_FAILED,
    LOGIN_REQUEST_STARTED,
    LOGIN_REQUEST_SUCCESS, LOGOUT_USER,
} from "./AuthConstants";
import {USER_KEY} from "../../helpers/TokenHelper";

const initialState = {
    error: '',
    loading: false,
    user: {},
    notification: {}
}

const reducer = (state = initialState, action) => {
    switch (action.type) {

        case LOGIN_REQUEST_STARTED:
            return {
                ...state,
                loading: true
            }
        case LOGIN_REQUEST_SUCCESS:

            localStorage.setItem(USER_KEY, JSON.stringify(action.payload));

            return {
                ...state,
                user: action.payload,
                loading: false
            }
        case LOGIN_REQUEST_FAILED:
            return {
                ...state,
                user: {},
                loading: false,
                error: action.payload
            }

        case LOGOUT_USER:
            localStorage.removeItem('user');
            return {
                ...state,
                user: {},
                loading: false
            }


        default:
            return state

    }
}

export default reducer;
